module.exports = __webpack_public_path__ + "b34f9752086833af44bffed5b4a0df81.svg";